import { render } from "./MPSVILeukocytes.vue?vue&type=template&id=5bb3080b&scoped=true"
import script from "./MPSVILeukocytes.vue?vue&type=script&lang=js"
export * from "./MPSVILeukocytes.vue?vue&type=script&lang=js"

import "./MPSVILeukocytes.vue?vue&type=style&index=0&id=5bb3080b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb3080b"]])

export default __exports__